import { createContext, useContext } from "react";
export const MainContainerContext = createContext(undefined);
export const useMainContainerContext = () => {
    const context = useContext(MainContainerContext);
    if (context === undefined) {
        throw new Error("Must be used within MainContainer");
    }
    return context;
};
export const MainContentContext = createContext(undefined);
export const useMainContentContext = () => {
    return useContext(MainContentContext);
};
//# sourceMappingURL=MainContainerContext.js.map